import React, { useEffect, useState } from 'react';
import { Field, Form, Formik } from "formik";
import DateRangePickerComponent from "../common/DateRangePickerComponent/DateRangePickerComponent"
import Button from "@material-ui/core/Button";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Modal from "../common/Modals/Modal";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import { NavLink } from "react-router-dom";
import { StyledBadge, textColors, useClasses } from "./styles";
import Pagination from "@material-ui/lab/Pagination";
import Preloader from "../common/Preloader/Preloader";
import Skeleton from '@material-ui/lab/Skeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePrevious } from "../common/CustomHook/usePrevious";
import { themeButtons } from "../../css/themeButtons";
import TextField from "@material-ui/core/TextField";
import * as Yup from "yup";
import Typography from "@material-ui/core/Typography";


const RenderFilters = ({ objects = {}, statusList = {}, filter = {}, setFilter, setPage }) => {
  let [filterCount, updateFilterCount] = useState(0);
  let [show, toggleModalShow] = useState(false);
  const objectKeys = Object.keys(objects);

  const filterClearValues = {
    datesBooking: [null, null],
    datesCheckIn: [null, null],
    datesCheckOut: [null, null],
    object: objectKeys,
    status: []
  };
  const calcFilterCount = values => {
    let result = 0;
    for (let oKey in values) {
      if (oKey === 'datesCheckIn' || oKey === 'object') continue;
      if (Array.isArray(values[oKey])) {
        if (values[oKey].join('')) {
          result++;
        }
      } else if (values[oKey]) {
        result++;
      }
    }
    return result;
  }

  const toggleShow = () => {
    toggleModalShow(!show)
  };

  const onSubmit = values => {
    updateFilterCount(calcFilterCount(values));
    toggleModalShow(false);
    setPage(1)
    setFilter(values)
  }

  return objectKeys.length ? (
    <div className="filters mb-2">
      <Formik initialValues={filter}
              onSubmit={onSubmit}
              enableReinitialize>
        {({ handleSubmit, setFieldValue, setValues, values }) => {

          const handleChangeObjectFilter = ({ target }) => {
            let curValue = target.value;
            if (curValue.length < 1) {
              setFieldValue(target.name, [Object.keys(objects)[0]]);
              return;
            }
            setFieldValue(target.name, curValue);
          }

          const handleClearFilterFields = () => {
            setValues(filterClearValues);
            setFilter(filterClearValues);
            updateFilterCount(0);
          }


          return (
            <Form onSubmit={handleSubmit}>
              <div className="row g-2 ">
                <div className="col-lg-4 h-100">
                  <DateRangePickerComponent
                    name="datesCheckIn"
                    startText="Дата заезда, от"
                    endText="Дата заезда, до"
                  />
                </div>
                <div className="col-lg-2 h-100">
                  <MuiThemeProvider theme={textColors}>
                    <Field name="object">
                      {({ field, form }) => (
                        <FormControl variant="outlined" size="small"
                                     className="w-100 mb-1 long-multiple-select">
                          <InputLabel htmlFor={`${field.name}_id`}>Гостевой
                            объект</InputLabel>
                          <Select
                            {...field}
                            onChange={handleChangeObjectFilter}
                            id={`${field.name}_id`}
                            multiple
                            displayEmpty
                            label="Гостевой объект"
                            renderValue={selected => selected.map((key) => objects[key].name).join(', ')}
                          >
                            {
                              Object.keys(objects).map((key) => {
                                let objectItem = objects[key];
                                return (
                                  <MenuItem key={key} value={key}>
                                    <Checkbox
                                      checked={field.value.indexOf(key) > -1}/>
                                    <ListItemText primary={objectItem.name}/>
                                  </MenuItem>
                                )
                              })
                            }
                          </Select>
                        </FormControl>
                      )}
                    </Field>
                  </MuiThemeProvider>
                </div>
                <div className="col-lg-6 h-100">
                  <div className="filters-btns">
                    <Button type="submit" className="btn filters-btn">
                      <FontAwesomeIcon icon={"search"} className="me-1"/> поиск
                    </Button>
                    <Button onClick={toggleShow} className="btn filters-btn">
                      <StyledBadge
                        badgeContent={filterCount}>
                        <FontAwesomeIcon icon={"filter"} className="me-1"/>

                        фильтры
                      </StyledBadge>

                    </Button>
                    <Button className="btn filters-btn" onClick={handleClearFilterFields}>
                      очистить
                    </Button>
                  </div>
                </div>
              </div>
              <Modal toggleShow={toggleShow} btnOkAction={handleSubmit} show={show} title={"Фильтры"}
                     textBtnOk={"Применить"}>
                <div className="row g-2">
                  <div className="col-12">
                    <DateRangePickerComponent
                      name="datesBooking"
                      startText="Дата бронирования, от"
                      endText="Дата бронирования, до"
                    />
                  </div>
                  <div className="col-12">
                    <DateRangePickerComponent
                      name="datesCheckOut"
                      startText="Дата выезда, от"
                      endText="Дата выезда, до"
                    />
                  </div>
                  <div className="col-12">
                    <MuiThemeProvider theme={textColors}>
                      <Field name="status">
                        {({ field, form }) => (
                          <FormControl variant="outlined" size={"small"}
                                       className={"w-100"}>
                            <InputLabel htmlFor={`${field.name}_id`}>Статус</InputLabel>
                            <Select
                              {...field}
                              id={`${field.name}_id`}
                              multiple
                              label="Статус"
                              renderValue={selected => selected.map((key) => statusList[key]).join(', ')}
                            >
                              {
                                Object.keys(statusList).map((key) => (
                                  <MenuItem key={key} value={key}>
                                    <Checkbox
                                      checked={field.value.indexOf(key) > -1}/>
                                    <ListItemText primary={statusList[key]}/>
                                  </MenuItem>
                                ))
                              }
                            </Select>
                          </FormControl>
                        )}
                      </Field>
                    </MuiThemeProvider>
                  </div>
                </div>
              </Modal>
            </Form>
          )
        }}
      </Formik>
    </div>
  ) : <Skeleton animation='wave' width='100%' height={35} variant='rect'/>;
}


const RenderBookingRow = ({ booking, setBookingStatus }) => {
  const [show, setShow] = useState(false)
  const [newStatusBooking, setNewStatusBooking] = useState()
  const toggleShow = (status) => {
    setNewStatusBooking(status)
    setShow(!show)
  }

  const reasonBooking = Yup.object().shape({
    reason: Yup.string()
      .matches(/\S/, 'Поле не заполнено')
      .required('Поле не заполнено'),
  })

  let activityBtn = Object.keys(booking.actions).filter(item => booking.actions[item])

  const btnItem = {
    "A": { text: "Подтвердить", btn: "btnGreen" },
    "F": { text: "Незаезд", btn: "btnDanger" },
    "C": { text: "Отказать", btn: "btnWarn" },
    "RT": { text: "Отменить", btn: "btnWarn" },
  }


  const updBookingStatus = (newStatus) => {
    setBookingStatus({ orderId: booking.orderId, status: newStatus })

  }


  const onSubmit = (value) => {
    setBookingStatus({ orderId: booking.orderId, status: newStatusBooking, reason: value.reason })
    toggleShow()
  }


  const buttons = themeButtons()
  let product = booking.room;
  return (
    <>


      <tr className="c-table__row">
        <td className=" c-table__cell">
          <span className="cell__title-mobile">№</span>
          {booking.orderId}
        </td>
        <td className="c-table__cell">
          <span className="cell__title-mobile">Дата бронирования</span>
          {booking.dateCreate}
        </td>
        <td className="c-table__cell">
          <span className="cell__title-mobile">Дата заезда / выезда</span>
          {booking.dateFrom + " / " + booking.dateTo}
        </td>
        <td className=" c-table__cell">
          <span className="cell__title-mobile">Размещение</span>
          <p className="m-0">{booking.name}</p>
          <p className="m-0">Номер: {product.name}</p>
          {booking.price ? null : (
            <>
              <p className="m-0 mb-2">Количество
                человек: {booking.totalCount} {booking.totalCountDetails}</p>
              <p className="m-0"><b>Контакты гостя:</b></p>
              <p className="m-0">{booking.userFullName}, {booking.userPhone}, {booking.userEmail}</p>
            </>
          )}
        </td>
        <td className="c-table__cell">
          <span className="cell__title-mobile">Статус</span>
          {booking.price ? booking.status.name : null}
        </td>
        <td className="c-table__cell">
          {booking.price ? (
            <>
              <span className="cell__title-mobile">Итоговая цена / комиссия</span>
              {`${booking.price} ₽ / ${booking.commission} ₽`}
            </>
          ) : null}

        </td>

        <td><Formik onSubmit={onSubmit}
                    validationSchema={reasonBooking}
                    initialValues={{ reason: '' }}>
          {({ handleSubmit, errors, touched, values }) => (
            <Form>
              <Modal toggleShow={toggleShow} btnOkAction={handleSubmit} show={show}
                     title={"Укажите причину отказа:"}
                     textBtnOk={"Отправить"}>
                <Field name="reason">
                  {({ field }) =>
                    <TextField
                      {...field}
                      className="mb-2 w-100"
                      multiline
                      rows={4}
                      label={"Причина отказа *"}
                      variant="outlined"
                      error={errors.reason}
                      helperText={errors.reason}
                    />
                  }

                </Field>

                <Typography variant="body2" display="block" color="error">
                  * - Обязательные поля
                </Typography>

              </Modal>

            </Form>
          )}
        </Formik></td>

        <td className="c-table__cell c-table__cell-btns">
          <Button component={NavLink}
                  to={`/lk/booking/detail/${booking.orderId}`}
                  className={`btn ${buttons.btnGreenOutline}`} variant="outlined">Просмотр</Button>

          {activityBtn.map(btn => <Button key={btn}
                                          onClick={() => (btn === "C" || btn === "RT") ? toggleShow(btn) : updBookingStatus(btn)}
                                          className={`btn ${buttons[btnItem[btn].btn]}`}>{btnItem[btn].text}</Button>
          )}
        </td>

      </tr>

    </>

  )
}


const RenderBookingTable = ({ bookings, setBookingStatus }) => {

  let skeletonCell = []
  for (let i = 0; i < 56; i++) {
    skeletonCell.push(<Skeleton animation='wave' key={i} height={35} variant='rect'/>)
  }

  return bookings ? (
    <table className="c-table booking percent">
      {bookings && bookings.length !== 0 && <thead className="c-table__row c-table__header">
      <tr>
        <th className=" c-table__cell">
          №
        </th>
        <th className="c-table__cell">
          Дата бронирования
        </th>
        <th className=" c-table__cell">
          Дата заезда / выезда
        </th>
        <th className=" c-table__cell">
          Размещение
        </th>
        <th className=" c-table__cell">
          Статус
        </th>
        <th className=" c-table__cell">
          Итоговая цена / комиссия
        </th>
        <th className=" c-table__cell">

        </th>
      </tr>
      </thead>}
      <tbody>
      {bookings ? Object.keys(bookings).map((booking, i) => <RenderBookingRow setBookingStatus={setBookingStatus}
                                                                              key={booking}
                                                                              booking={bookings[booking]}/>) : null}
      </tbody>
    </table>
  ) : (
    <>
      <div style={{ display: 'flex' }}>
        <Skeleton style={{ marginBottom: 5, flex: '1 1 auto' }} animation='wave' height={35}
                  variant='rect'/>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: "repeat(7, 1fr)", gridGap: "5px" }}>
        {skeletonCell}
      </div>
    </>
  )
}

const formatDate = (date) => {
  return `${date.toLocaleDateString('ru-RU')}`
}

const formatFilter = (filters) => {
  if (filters.datesBooking[0]) {
    filters.datesBooking[0] = formatDate(new Date(filters.datesBooking[0]));
  }

  if (filters.datesBooking[1]) {
    filters.datesBooking[1] = formatDate(new Date(filters.datesBooking[1]));
  }

  if (filters.datesCheckIn[0]) {
    filters.datesCheckIn[0] = formatDate(new Date(filters.datesCheckIn[0]));
  }

  if (filters.datesCheckIn[1]) {
    filters.datesCheckIn[1] = formatDate(new Date(filters.datesCheckIn[1]));
  }

  if (filters.datesCheckOut[0]) {
    filters.datesCheckOut[0] = formatDate(new Date(filters.datesCheckOut[0]));
  }

  if (filters.datesCheckOut[1]) {
    filters.datesCheckOut[1] = formatDate(new Date(filters.datesCheckOut[1]));
  }
}

const Booking = (props) => {
  // Кеш страниц с бронированиями, в том числе с применённым фильтром
  const [cachePagesWithNavParams, setCachePagesWithNavParams] = useState({});
  const [page, setPage] = useState(1);

  const {
    objectId, objects, bookings, statusList, navParams, getBookingList, getStatusList,
    setBookingListFromCache, getNavParams, setNavParamsFromCache, searchObjects, userRole,
    setBookingStatus, headerSubtitle
  } = props;

  const classes = useClasses();


  const prevObjectId = usePrevious(objectId)
  useEffect(() => {
    if (objectId !== prevObjectId) {
      setBookingListFromCache(null);
    }
  }, [objectId])


  // один раз получает инфу по объектам и статусам бронирований для фильтра
  useEffect(() => {
    getStatusList();
  }, []);

  useEffect(() => {
    if (!objects && objectId && userRole === "MODERATOR") {
      searchObjects(objectId)
    }
  }, [objects])


  // Состояние фильра
  let [filter, setFilter] = useState({
    datesBooking: [null, null],
    datesCheckIn: [null, null],
    datesCheckOut: [null, null],
    status: [],
    object: [],
  });


  //общее количество выбранных фильтров
  const filtersCondition = [...filter.datesBooking, ...filter.datesCheckIn, ...filter.datesCheckOut, ...filter.status].filter(item => item).length

  // Т.к. в начальном фильтре не указаны объекты, нужно установить состояние фильтра и добавить туда ID объектов, если они уже пришли в props

  if (filter.object.length < 1 && objects && objects.length !== 0) {
    setFilter({ ...filter, object: objectId ? [objectId] : Object.keys(objects) });
  }

  const prevFilters = usePrevious(JSON.stringify(filter));
  /*
   Получаем список броней на основе фильтра и параметров пагинации. Если страница уже в кеше - сразу отправляем её в
   props прямо из состояния компонента. Если ещё не сохраняли - сбрасываем текущий список броней (HACK: для вызова лоадера),
   после делаем запрос на получение броней
   */
  useEffect(() => {

    if (!cachePagesWithNavParams.hasOwnProperty(JSON.stringify(filter) + '_' + page)) {
      if (objects) {
        let filterForRequest = JSON.parse(JSON.stringify(filter));
        formatFilter(filterForRequest);

        getBookingList({
          filter: JSON.stringify(filterForRequest),
          page: page
        })


        if (prevFilters !== JSON.stringify(filter)) {
          getNavParams({
            filter: JSON.stringify(filterForRequest)
          });
        }


      }
    } else {

      setBookingListFromCache(cachePagesWithNavParams[JSON.stringify(filter) + '_' + page]['items']);
      setNavParamsFromCache(cachePagesWithNavParams[JSON.stringify(filter) + '_' + page]['navParams']);
    }

  }, [getBookingList, filter, page]);


  // После изменения страницы, сохраняем текущую в кеш (если её ещё там нет), со всеми установленными фильтрами
  const handleChange = (event, value) => {
    setBookingListFromCache(null);
    if (!cachePagesWithNavParams.hasOwnProperty(JSON.stringify(filter) + '_' + page)) {
      let newPage = {};
      newPage[JSON.stringify(filter) + '_' + page] = {};
      newPage[JSON.stringify(filter) + '_' + page]['items'] = bookings;
      newPage[JSON.stringify(filter) + '_' + page]['navParams'] = navParams;
      setCachePagesWithNavParams({ ...cachePagesWithNavParams, ...newPage });
    }
    setPage(value);
  };


  if (!objects || !bookings) {
    return <Preloader loading={true} text={"Ищем ваши бронирования"}/>
  }
  return (
    <div className={`main bookings ${headerSubtitle ? "edit-object" : ''}`}>
      <div className="container-fluid">
        {objects && objects.length !== 0 && <RenderFilters objects={objects}
                                                           objectId={objectId}
                                                           statusList={statusList}
                                                           filter={filter}
                                                           setPage={setPage}
                                                           setFilter={setFilter}/>}

        {navParams && navParams['pages'] > 1 &&
          <Pagination className={`${classes.pagination} mb-2 ms-auto`} count={navParams['pages']} page={page}
                      onChange={handleChange}/>}


        <RenderBookingTable setBookingStatus={setBookingStatus} bookings={bookings}/>

        {bookings && bookings.length === 0 && <h6 className="w-100 text-center mt-5">
          {filtersCondition === 0
            ? "На выбранном объекте пока нет бронирований"
            : "Нет бронирований, по выбранным фильтрам"
          }
        </h6>}

      </div>
    </div>
  );
};


export default Booking;
